export default __webpack_public_path__ + "effe0bbd4d421c53bcd78f3ad5e0341c.png";